import { render, staticRenderFns } from "./AccueilMaternite.vue?vue&type=template&id=6b9a10be&"
import script from "./AccueilMaternite.vue?vue&type=script&lang=ts&"
export * from "./AccueilMaternite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
